// extracted by mini-css-extract-plugin
module.exports = {"TooltipLabel":"Tooltip_TooltipLabel__1fyOP","Triangle":"Tooltip_Triangle__2syeb","TooltipWithHotkey":"Tooltip_TooltipWithHotkey__1eHv_"};